import { render, staticRenderFns } from "./PageSlidesCreate.vue?vue&type=template&id=46192810&"
import script from "./PageSlidesCreate.vue?vue&type=script&lang=js&"
export * from "./PageSlidesCreate.vue?vue&type=script&lang=js&"
import style0 from "./PageSlidesCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports